function buildCodeLines(lines, replacements) {
  return lines.map((line) => {
    let result = line;
    Object.keys(replacements).forEach((key) => {
      result = result.replace(new RegExp(key, 'g'), replacements[key]);
    });
    return result;
  }).join('\n');
}

export function getSnippet(tab, widgetType, publishableKey) {
  const pk = publishableKey || 'YOUR_PUBLISHABLE_KEY';
  const base = 'https://ants-rt-widget.sports.dev.roanuz.com';
  const sc = 'script';
  const sOpen = '<'.concat(sc, '>');
  const sClose = '</'.concat(sc, '>');
  const sSrc = '<'.concat(
    sc, ' src="/ants-widgets.js">', sClose,
  );
  const wt = widgetType || 'matches';
  const vars = {
    __PK__: pk,
    __BASE__: base,
    __WIDGET__: wt,
    __S_OPEN__: sOpen,
    __S_CLOSE__: sClose,
    __S_SRC__: sSrc,
  };

  const snippets = {
    html: {
      filename: 'index.html',
      code: buildCodeLines([
        '<!DOCTYPE html>',
        '<html lang="en">',
        '<head>',
        '  <meta charset="UTF-8" />',
        '  <title>Cricket Widget</title>',
        '</head>',
        '<body style="margin: 0; background: var(--bg-page, #0a0e1a);">',
        '  <div id="cricket-widget"',
        '    style="height: 500px; overflow-y: auto;">',
        '  </div>',
        '',
        '  __S_SRC__',
        '  __S_OPEN__',
        '    AntsWidgets.mount(\'#cricket-widget\', {',
        '      widget: \'__WIDGET__\',',
        '      publishableKey: \'__PK__\',',
        '      baseUrl: \'__BASE__\',',
        '    });',
        '  __S_CLOSE__',
        '</body>',
        '</html>',
      ], vars),
    },
    vue: {
      filename: 'CricketWidget.vue',
      code: buildCodeLines([
        '<template>',
        '  <div id="cricket-widget"',
        '    style="height: 500px; overflow-y: auto;">',
        '  </div>',
        '</template>',
        '',
        '__S_OPEN__',
        'export default {',
        '  mounted() {',
        '    window.AntsWidgets.mount(\'#cricket-widget\', {',
        '      widget: \'__WIDGET__\',',
        '      publishableKey: \'__PK__\',',
        '      baseUrl: \'__BASE__\',',
        '    });',
        '  },',
        '  beforeDestroy() {',
        '    window.AntsWidgets.unmount(\'#cricket-widget\');',
        '  },',
        '};',
        '__S_CLOSE__',
      ], vars),
    },
    angular: {
      filename: 'cricket-widget.component.ts',
      code: buildCodeLines([
        'import { Component, AfterViewInit, OnDestroy }',
        '  from \'@angular/core\';',
        '',
        'declare const AntsWidgets: any;',
        '',
        '@Component({',
        '  selector: \'app-cricket-widget\',',
        '  template: `',
        '    <div id="cricket-widget"',
        '      style="height: 500px; overflow-y: auto;">',
        '    </div>',
        '  `,',
        '})',
        'export class CricketWidgetComponent',
        '  implements AfterViewInit, OnDestroy {',
        '',
        '  ngAfterViewInit() {',
        '    AntsWidgets.mount(\'#cricket-widget\', {',
        '      widget: \'__WIDGET__\',',
        '      publishableKey: \'__PK__\',',
        '      baseUrl: \'__BASE__\',',
        '    });',
        '  }',
        '',
        '  ngOnDestroy() {',
        '    AntsWidgets.unmount(\'#cricket-widget\');',
        '  }',
        '}',
      ], vars),
    },
    react: {
      filename: 'CricketWidget.tsx',
      code: buildCodeLines([
        '\'use client\';',
        'import { useEffect, useRef } from \'react\';',
        'import Script from \'next/script\';',
        '',
        'export default function CricketWidget() {',
        '  const mounted = useRef(false);',
        '',
        '  useEffect(() => {',
        '    if (mounted.current) return;',
        '    mounted.current = true;',
        '',
        '    const interval = setInterval(() => {',
        '      if ((window as any).AntsWidgets) {',
        '        clearInterval(interval);',
        '        (window as any).AntsWidgets.mount(\'#cricket-widget\', {',
        '          widget: \'__WIDGET__\',',
        '          publishableKey: \'__PK__\',',
        '          baseUrl: \'__BASE__\',',
        '        });',
        '      }',
        '    }, 100);',
        '',
        '    return () => {',
        '      clearInterval(interval);',
        '      (window as any).AntsWidgets?.unmount(\'#cricket-widget\');',
        '    };',
        '  }, []);',
        '',
        '  return (',
        '    <>',
        '      <Script src="/ants-widgets.js" strategy="afterInteractive" />',
        '      <div id="cricket-widget" style={{ height: \'500px\', overflowY: \'auto\' }} />',
        '    </>',
        '  );',
        '}',
      ], vars),
    },
  };

  return snippets[tab] || snippets.html;
}

export function buildPreviewHtml(widgetType, publishableKey) {
  const pk = publishableKey || 'YOUR_PUBLISHABLE_KEY';
  const base = 'https://ants-rt-widget.sports.dev.roanuz.com';
  const wt = widgetType || 'matches';
  const sc = 'script';
  const scriptUrl = 'https://ants-widget.sports.dev.roanuz.com/ants-widgets.js';
  return [
    '<!DOCTYPE html>',
    '<html><head><meta charset="UTF-8">',
    '<style>',
    '  body { margin: 0; font-family: sans-serif; }',
    '  #widget { height: 100vh; overflow-y: auto; }',
    '</style>',
    '</head><body>',
    '<div id="widget"></div>',
    '<'.concat(sc, ' src="', scriptUrl, '"></', sc, '>'),
    '<'.concat(sc, '>'),
    '  AntsWidgets.mount("#widget", {',
    '    widget: "'.concat(wt, '",'),
    '    publishableKey: "'.concat(pk, '",'),
    '    baseUrl: "'.concat(base, '",'),
    '  });',
    '</'.concat(sc, '>'),
    '</body></html>',
  ].join('\n');
}
